import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';
import Modal from '../Modal/Modal';

type VideoModalProps={

};

const VideoModal: React.FC<VideoModalProps> = (): ReactElement => {
    const { presentationState, state } = useContext(AppContext);
    useEffect(() => {
        presentationState?.setWidth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getVideoDimensionsOf = (url: string): Promise<{ height: number, width: number}> => {

        return new Promise(resolve => {
            // create the video element
            const video = document.createElement('video');

            // place a listener on it
            video.addEventListener('loadedmetadata', function () {
                // retrieve dimensions
                const height = this.videoHeight;
                const width = this.videoWidth;

                // send back result
                resolve({ height, width });
            }, false);

            // start download meta-datas
            video.src = url;
        });
    };

    const [ratio, setRatio] = useState(1.2);

    useEffect(() => {

        presentationState?.showVideo?.url?.original && getVideoDimensionsOf(presentationState?.showVideo.url.original).then(result => {

            setRatio(result.width / result.height);
        });
    }, [presentationState?.showVideo?.url?.original]);

    return useObserver(() => (
        <Modal
            showModal={!!presentationState?.showVideo}
            onBackdropClick={(): void => presentationState?.setShowVideo(undefined)}
            modalPaperStyle={{
                maxHeight: '100%',
                margin: 0,
                maxWidth: '100%',
                height: isMobile() ? 'unset' : 'calc(100% - 2rem)',
                width: isMobile() ? '100%' : ((presentationState?.modalWidth && `calc(${presentationState?.modalWidth * (ratio ? (ratio) : 1.2)}px - 2rem)`) || '80vh'),
                borderRadius: '2rem',
                overflow:'hidden' }}>
            {(!!presentationState?.showVideo?.url) && <ReactPlayer
                muted
                controls
                playsinline
                width={'100%'}
                style={{ marginBottom: '-1rem' }}
                height={'auto'}
                url={presentationState?.showVideo.url.original || ''}
            >
            </ReactPlayer>}
        </Modal>
    ));
};


export default VideoModal;